/*
 * @Author: lixiang
 * @Date: 2021-12-23 15:56:54
 * @Description: 项目弹框相关
 */
/**
 * @description: 确认框
 * @param {*} _this
 * @param {*} content
 * @return {*}
 */
export function confirm(_this,content,sureCallBack,cancelCallback,confirmButtonText='确定',cancelButtonText='取消',showCancelButton=true,showClose=true){
    _this.$confirm(content, '提示', {
        confirmButtonText,
        cancelButtonText,
        showCancelButton:showCancelButton,
        type: 'warning',
        showClose
      }).then(() => {
        sureCallBack()
      }).catch(() => {
        cancelCallback()         
      });
}

/**
 * @description: toast提示
 * @param {*}
 * @return {*}
 */
export function toast(_this,message,type='warning',showClose = true,duration=1000,){
    _this.$message({
        showClose: showClose,
        type,
        message,
        duration
      });
}
